import { connect } from 'react-redux'
import { compose } from 'redux'
import getData from '../functions/getData'
import { PROGRAM_COLLECTIONS_ITEMS } from '../constants/state'

const mapStateToProps = state => ({
    collections: getData(state, PROGRAM_COLLECTIONS_ITEMS)
})

const hasCollections = () => WrappedComponent => {

    const HasCollections = props => <WrappedComponent {...props} />

    return compose(
        connect(mapStateToProps, null)
    )(HasCollections)
}

export default hasCollections